module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/review/review.component.scss
// module id = ./src/app/components/review/review.component.scss
// module chunks = main